import React, { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import PerfectScrollbar from "perfect-scrollbar"
import styles from "./styles.less"
import ResizeSensor from "css-element-queries/src/ResizeSensor"

class Scrollable extends Component {
  static defaultProps = {
    suppressScrollX: true,
    suppressScrollY: false,
    className: "",
  }
  static propTypes = {
    suppressScrollX: PropTypes.bool,
    suppressScrollY: PropTypes.bool,
    className: PropTypes.string,
  }

  perfectScrollbar = null

  constructor(props) {
    super(props)
    this.updateScrollbar = this.updateScrollbar.bind(this)
  }

  componentDidMount() {
    this.initScrollbar()
    this.initResizeSensor()
    window.addEventListener("resize", this.updateScrollbar)
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    this.detachResizeSensor()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.updateScrollbar()
    this.initResizeSensor()
  }

  componentWillUnmount() {
    this.detachResizeSensor()
    window.removeEventListener("resize", this.updateScrollbar)
    this.perfectScrollbar && this.perfectScrollbar.destroy()
    this.perfectScrollbar = null
  }

  detachResizeSensor() {
    if (this._resizeSensor != null) {
      this._resizeSensor.detach()
      this._resizeSensor = null
    }
  }

  initResizeSensor() {
    this._resizeSensor = new ResizeSensor(this._resizeSensorContainer, this.updateScrollbar)
  }

  initScrollbar() {
    this.perfectScrollbar = new PerfectScrollbar(this._scrollable, this.getScrollbarOptions())
  }

  updateScrollbar() {
    this.perfectScrollbar && this.perfectScrollbar.update()
  }

  getScrollbarOptions() {
    return {
      suppressScrollX: this.props.suppressScrollX,
      suppressScrollY: this.props.suppressScrollY,
      wheelPropagation: false,
    }
  }

  render() {
    var className = this.props.className
      ? classnames(styles.scrollable, this.props.className)
      : styles.scrollable
    return (
      <div ref={(c) => (this._scrollable = c)} className={className}>
        <div ref={(c) => (this._resizeSensorContainer = c)}>{this.props.children}</div>
      </div>
    )
  }
}

export default Scrollable
